import { render, staticRenderFns } from "./JobPointTable.vue?vue&type=template&id=ff9039d8"
import script from "./JobPointTable.vue?vue&type=script&lang=js"
export * from "./JobPointTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports